module.exports = __webpack_public_path__ + "img/Image_Lobby_Copyright_HotellerieSuisse.c550909a.jpg";